import React from 'react';
import { post } from '../../../model/post';
import { StyledComponentProps } from '@material-ui/core/styles';
import Button from '../../../ui-components/Button/EditButton';

interface IAlertProps extends StyledComponentProps {
    post: post;
    navigateTo: (path: string) => void
}

export const EditButton = (props: IAlertProps) => (
        <Button onClick={() => props.navigateTo(`/private/edit/${props.post._id}`)}>
        </Button>
);
